export enum StorePlatform {
    appleStore = "appleStore",
    googlePlatform = "googlePlatform",
    telegram = "telegram",
    comingSoon = "comingSoon",
}